module.exports = __webpack_public_path__ + "static/media/andrei_spitelnicu.a2b6635d.jpg";